import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { propertyNotEmpty } from "../../../../utils/not-empty";

import type { SupabaseSegmentWithFavourite } from "../../../segment/server/supabase-segment-service";
import type { PermissionsFormType } from "../../types";
import type { FC } from "react";

export const SegmentDenyListSelect: FC<{
  segments: SupabaseSegmentWithFavourite[];
}> = ({ segments }) => {
  const allowedSegments = segments
    .filter(propertyNotEmpty("name"))
    .map((s) => ({ title: s.name, id: s.id }));

  const { control } = useFormContext<PermissionsFormType>();

  return (
    <Controller
      name="segment_deny_list"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          multiple={true}
          value={allowedSegments.filter((s) => field.value?.includes(s.id))}
          options={[{ title: "Select All", id: "All" }].concat(allowedSegments)}
          renderOption={(renderProps, option) => (
            <Box component="li" {...renderProps} key={option.id}>
              {option.title}
            </Box>
          )}
          renderValue={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.title} />
            ))
          }
          renderInput={(params) => (
            <TextField
              label="Restricted Segments"
              {...params}
              sx={{ mt: 2 }}
              helperText={
                error?.message ??
                "Create/edit segment will be disabled for users with restricted segments"
              }
              error={Boolean(error)}
              slotProps={{
                input: { ...params.InputProps, "data-testid": "segment-deny-list-select" },
              }}
            />
          )}
          getOptionLabel={(option) => option.title}
          onChange={(_, v) => {
            const value = v.map((s) => s.id);
            field.onChange(value.includes("All") ? allowedSegments.map((p) => p.id) : value);
          }}
        />
      )}
    />
  );
};
